import { DEFAULT_FILTER_VALUE } from '../../constants/PremiumConstants';
import { ACTION } from './interfaces';

import type { FreemiumAction, IFreemiumState } from './interfaces';

const INIT_FREEMIUM_STATE: IFreemiumState = {
  featuresOfPremiumRef: null,
  isPremiumOverviewLoading: true,
  isPremiumAnalyticsFilterModalOpen: false,
  isListingActive: false,
  updatedTimestamps: [],
  filters: {
    filterType: 'cityState',
    beds: DEFAULT_FILTER_VALUE,
    propertyType: DEFAULT_FILTER_VALUE,
  },
  canAccessTopOfFunnelPremium: false,
};

const reducer = (state: IFreemiumState, action: FreemiumAction): IFreemiumState => {
  switch (action.type) {
    case ACTION.UPDATE_FILTERS: {
      const { filters } = (action as Extract<FreemiumAction, { type: ACTION.UPDATE_FILTERS }>).payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          ...filters,
        },
      };
    }
    case ACTION.UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS: {
      const { isPremiumOverviewLoading } = (
        action as Extract<FreemiumAction, { type: ACTION.UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS }>
      ).payload;
      return {
        ...state,
        isPremiumOverviewLoading,
      };
    }
    case ACTION.UPDATE_DATA: {
      const { data } = (action as Extract<FreemiumAction, { type: ACTION.UPDATE_DATA }>).payload;
      return {
        ...state,
        ...data,
      };
    }
    case ACTION.ADD_UPDATED_TIMESTAMP: {
      const { updatedTimestamp } = (action as Extract<FreemiumAction, { type: ACTION.ADD_UPDATED_TIMESTAMP }>).payload;
      const updatedTimestampsCopy = [...state.updatedTimestamps];
      updatedTimestampsCopy.push(updatedTimestamp);
      return {
        ...state,
        updatedTimestamps: updatedTimestampsCopy,
      };
    }
    case ACTION.UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS: {
      const { isPremiumAnalyticsFilterModalOpen } = (
        action as Extract<FreemiumAction, { type: ACTION.UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS }>
      ).payload;
      return {
        ...state,
        isPremiumAnalyticsFilterModalOpen,
      };
    }

    case ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM: {
      const { canAccessTopOfFunnelPremium } = (
        action as Extract<FreemiumAction, { type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM }>
      ).payload;
      return {
        ...state,
        canAccessTopOfFunnelPremium,
      };
    }

    default: {
      return state;
    }
  }
};

export { INIT_FREEMIUM_STATE };

export default reducer;
